/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {TableComponent} from './table.component';
import {TableHeaderComponent} from './table-header/table-header.component';
import {TooltipModule} from '../tooltip/tooltip.module';
import {TableLineComponent} from './table-line/table-line.component';
import {LoadingSpinnerModule} from '../loading/loading-spinner/loading-spinner.module';
import {PipesModule} from '../pipes/pipes.module';
import {StatusDotModule} from '../status-dot/status-dot.module';
import {PathAlertsModule} from '../path-alerts/path-alerts.module';
import {FlagModule} from '../flag/flag.module';
import {TableLabelComponent} from './table-label/table-label.component';
import {CopyPasteModule} from '../copy-paste/copy-paste.module';

@NgModule({
    declarations: [TableComponent, TableLabelComponent, TableHeaderComponent, TableLineComponent],
    imports: [
        CommonModule,
        TooltipModule,
        LoadingSpinnerModule,
        PipesModule,
        StatusDotModule,
        PathAlertsModule,
        FlagModule,
        CopyPasteModule
    ],
    exports: [TableComponent]
})
export class TableModule {
}
